<div class="modal-close">
  <button nxButton (click)="handleClose()">{{ 'common.close' | translate }}</button>
</div>
